module.exports = __webpack_public_path__ + "img/ic_suc_12.60d620f5.svg";